import { expectString } from "./schema";
export const APP_MODES = ["family", "operator"];
export function isAppMode(value) {
    return APP_MODES.includes(value);
}
export function parseAppMode(value, path = "appMode") {
    const appMode = expectString(value, path);
    if (!isAppMode(appMode)) {
        throw new Error(`${path} must be one of: ${APP_MODES.join(", ")}`);
    }
    return appMode;
}
